
export function hideAllTippy() {
    [...document.querySelectorAll('*')].forEach(node => {
        if (node._tippy) {
            node._tippy.destroy()
        }
    })
}

// Check whether this action has already been requested
export function isRequested(id, action, dataList) {
    return dataList.includes( String(id) + action )
}

// Return whether a distribution has paths without links
export function hasPathsUnlinked(distribution) {
    if (distribution.children().length) {
        let hasPathsUnlinked = false
        distribution.children().forEach(child => {
            if (child.connectedEdges().length === 0) {
                hasPathsUnlinked = true
            }
        })
        return hasPathsUnlinked
    }
    return false
}

// Adjust different node's label length for different node width
export function sentenceTrimmerSingleLine(node) {
    let sentence = node.data().name
    // In accordance with paths' width (200px + 0px(padding)) and font(11px Helvatica bold)
    let maximumLength = 25
    if (node.classes().indexOf('distribution') != -1) {
        // In accordance with distribution's width (200px + 5px (padding)) and font (11px Helvatica bold)
        maximumLength = 36
    } else if (node.classes().indexOf('dataset') != -1) {
        // In accordance with dataset's width (210px + 10 (padding)) and font (11px Helvatica bold)
        maximumLength = 40
    }
    if (node.isChildless()) {
        // Node will not have padding if it doesn't have child
        maximumLength = maximumLength - 1
    }
    if (sentence.length <= maximumLength) { return sentence }
    return sentence.slice(0, maximumLength) + "…"
}

// Restrict maximum length to be 25, first string is 15 characters long, second string is 10 characters long
export function sentenceTrimmer(sentence, maximumLength=25, firstLength=15, lastLength=10) {
    let firstString
    let lastString = ""
    let indexOfSpace
    if (sentence.length <= maximumLength) { return sentence; }
    firstString = sentence.slice(0, firstLength)
    indexOfSpace = Math.min(firstString.length, firstString.lastIndexOf(" "))
    firstString = firstString.substr(0, indexOfSpace) ? firstString.substr(0, indexOfSpace) : firstString

    lastString = sentence.slice(-lastLength)
    indexOfSpace = lastString.indexOf(" ")
    lastString = "…" + (lastString.slice(indexOfSpace + 1) ? lastString.slice(indexOfSpace + 1) : lastString)
    return firstString + lastString
}

// Get label width
export function getLabelWidth(txt, font) {
    if(getLabelWidth.c === undefined){
        getLabelWidth.c=document.createElement('canvas')
        getLabelWidth.ctx=getLabelWidth.c.getContext('2d')
    }
    if(getLabelWidth.ctx.font !== font)
        getLabelWidth.ctx.font = font
    return getLabelWidth.ctx.measureText(txt).width
}

export function adjustSize(cy, isExpanded) {
    if (isExpanded) {
        $('#cytoscape-div').css('height', 'calc(100vh - 100px)')
    } else {
        $('#cytoscape-div').css('min-height', '580px')
        $('#cytoscape-div').css('height', '580px')
    }
    cy.resize()
    cy.fit(50)
}

// Get connected edges for a provenance
export function getConnectedProvenanceEdges(event, cy) {
    return cy.edges().filter(edge => {
        if (edge.data().provenance == event.target.data().provenance) {
            return edge
        }
    })
}

// Get connected edges when path or distribution's linkage is cliced
export function getConnectedLinkage(event, cy) {
    let linkedEdgeId = event.target.data().linkedEdgeId
    if (linkedEdgeId) {
        return cy.edges(`.${linkedEdgeId}`)
    }
}
